var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShiftIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99984 0.666504C1.27113 0.666504 0.666504 1.27113 0.666504 1.99984V9.99984C0.666504 10.7285 1.27113 11.3332 1.99984 11.3332H13.9998C14.7285 11.3332 15.3332 10.7285 15.3332 9.99984V1.99984C15.3332 1.27113 14.7285 0.666504 13.9998 0.666504H1.99984ZM1.99984 1.99984H13.9998V9.99984H1.99984V1.99984ZM7.99984 3.33317L5.33317 5.99984H7.33317V8.6665H8.6665V5.99984H10.6665L7.99984 3.33317Z",
    fill: "#5C5F62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShiftIc);
export default __webpack_public_path__ + "static/media/shiftIc.5084bc7687690f48e92347653a59de78.svg";
export { ForwardRef as ReactComponent };